<template>
  <modal name="modalInfo" class="event-modal" :height="calculateHeight" :class="{'v--modal-box v--modal':isChangeOrder, 'modal-delete' : isDeleteModal}" :width="700" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>{{ modalData.title }}</span>
      </div>
      <!-- <div class="line"></div> -->
    </div>
    <div class="modal-body">
      <ModalInfoBody v-if="showModalBody" :messages="bodyMessage"></ModalInfoBody>
    </div>
    <div class="modal-footer">
      <b-button v-if="modalData.btnLeft != ''" class="modal-btn-left ap-btn secondary" @click="hideModal()">
        {{ modalData.btnLeft }}
      </b-button>
      <b-button v-if="modalData.btnRight != ''" class="modal-btn-right ap-btn primary" @click="btnAction()">
        {{ modalData.btnRight }}
      </b-button>
    </div>
  </modal>
</template>
<script>
// import Vue from 'vue';
import ModalInfoBody from './ModalInfoBody';
import consts from '../../_consts';
import { mapActions } from 'vuex';
// const _ = require('lodash');

export default {
  name: '',
  components: {
    ModalInfoBody
  },
  data () {
    return {
      actionTypes: consts.modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: consts.modalBodies
    }
  },
  methods: {
    hideModal () {
      this.$emit('CLOSE_MODAL_INFO', false);
      this.$modal.hide('modalInfo');
    },
    beforeOpen (event) {
      this.modalData = consts.mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    async btnAction () {
      this.$modal.hide('modalInfo');
      this.$emit('CLOSE_MODAL_INFO', true);
    },
    ...mapActions({
    }),
    beforeClose () {
    }
  },
  computed: {
    calculateHeight () {
      if (this.modalData.modalAction === this.actionTypes.deleteEvent) {
        return 290;
      }
      return 'auto';
    },
    isChangeOrder () {
      return this.modalData.modalAction === this.actionTypes.changeOrder;
    },
    isDeleteModal () {
      return this.modalData.modalAction === this.actionTypes.deleteEvent;
    },
    bodyMessage () {
      if (this.modalData.modalAction === this.actionTypes.eventNameNotUnique) {
        return this.modalBodies.eventNameNotUnique;
      }
      if (this.modalData.modalAction === this.actionTypes.someFieldsBlank) {
        return this.modalBodies.someFieldsBlank;
      }
      if (this.modalData.modalAction === this.actionTypes.eventDurationRestricted) {
        return this.modalBodies.eventDurationRestricted;
      }
      if (this.modalData.modalAction === this.actionTypes.readOnly) {
        return this.modalBodies.readOnly;
      }
      if (this.modalData.modalAction === this.actionTypes.emailMustBeAValid) {
        return this.modalBodies.emailMustBeAValid;
      }
      if (this.modalData.modalAction === this.actionTypes.modalAlertChangeEmailTemplate) {
        return this.modalBodies.modalAlertChangeEmailTemplate;
      }
      if (this.modalData.modalAction === this.actionTypes.modalCancelEmail) {
        return this.modalBodies.modalCancelEmail;
      }
    },
    showModalBody () {
      let actionTypes = this.actionTypes;
      let listModal = [actionTypes.eventNameNotUnique, actionTypes.someFieldsBlank, actionTypes.eventDurationRestricted, actionTypes.readOnly, actionTypes.emailMustBeAValid, actionTypes.modalCancelEmail, actionTypes.modalAlertChangeEmailTemplate];
      return listModal.indexOf(this.modalData.modalAction) >= 0;
    },
    bodyMessageWithErrorCode () {
      let messages = [];
      let data = this.actionData;
      for (let prop in data) {
        if (data[prop]) {
          let temp = consts.modalBodies[prop][0];
          messages.push(temp);
        }
      }
      return messages;
    }
  }
}
</script>

<style lang="less">
@import '../../styles/variables.less';

.event-modal {
  &.modal-change-order-detail {
    .v--modal-box {
      overflow-y: scroll;
    }
  }
  margin: 0;
  background: rgba(0, 0, 0, 0.4);

  .modal-header {
    padding: 0;
    border: 0;
    border-bottom: 1px solid #c2cfd6;
    width: 85%;
    margin: 0 auto;

    .line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid #E6E6E6;
    }
    .modal-header-text {
      margin-top: 50px;
      height: 29px;
      // width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
      text-transform: uppercase;
    }
    .modal-header-change-order-text{
      margin-top: 25px;
      margin-left: 25px;
      height: 29px;
      width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
      text-transform: uppercase;
    }
    .modal-header-line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid @grey-4;
    }
  }
  .modal-body {
    height: auto;
    width: 85%;
    margin: 0 auto;
    padding: 20px 0 0 0;

    .modal-body-text {
      font-family: @font-family-main;
      color: @grey-8;
      font-size: 16px;
      line-height: 24px;
    }

  }
  .modal-body-changeOrderDetail{
    .modal-body-changeOrderDetail-text{
      margin-top: 25px;
      margin-left: 25px;
      color: @black;
      font-family: @font-family-main;
      font-size: 14px;
      line-height: 14px;
    }
    .modal-body-changeOrderDetail-event-detail{
      margin: 26px 0 0 0;
    }
  }
  .modal-footer {
    /*position: absolute;*/
    bottom: 0;
    right: 0;
    padding: 0;
    float: right;
    border: 0;
    .modal-btn-left {
      border-radius: 4px;
      margin-left: 15px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-left-text {
        color: @blue;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
    .modal-btn-right {
      border-radius: 4px;
      margin-right: 50px;
      margin-bottom: 50px;
      margin-top: 30px;
      .modal-btn-right-text {
        color: @white;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ModalInfo.vue?3b0d3f5f